import {connect} from 'react-redux';
import {actions, Form} from 'forms/rrf';
import {Col, Row} from 'react-bootstrap';
import RequiredInput from '../../../common/form/elements/required-input';
import FileUpload from '../../../common/form/elements/file-upload';
import ArrowButton from '../../../common/button-arrow';
import {updateFile} from '../../../../actions/files';

const EditDownloadForm = ({dispatch, file, formValid}) => {
  const onSubmit = (payLoad) => {
    dispatch(actions.submitFields('deep.admin_category', updateFile(file.id, payLoad)));
  };

  return (
    <Form model="deep.admin_files.edit" onSubmit={onSubmit}>
      <Row>
        <Col lg={12}>
          <RequiredInput
            controlId="name"
            label="Filename"
            model=".name"
            placeholder="Name"
          />
        </Col>
      </Row>
      <Row>
        <Col lg={12}>
          <FileUpload label="Replace this File (optional)"/>
        </Col>
      </Row>
      <Row>
        <Col lg={12}>
          <ArrowButton
            className="float-end"
            color="grey"
            disabled={!formValid}
          >
            Update
          </ArrowButton>
        </Col>
      </Row>
    </Form>
  );
};

const mapStateToProps = state => ({
  formValid: state.deep.forms.admin_files.edit.$form.valid
});

export default connect(mapStateToProps)(EditDownloadForm);
